<template>
  <div class="header">
    <div class="nav-left">
      <a href="/"
        ><img
          src="@/assets/logo.png/"
          height="37"
          width="152"
      /></a>
      <a
        href="/"
        class="active">
        首页
      </a>
    </div>
    <div class="nav-right">
      <a
        v-if="getUserInfo.token"
        class="creatorbtn btn-primary"
        :href="creatorCenterUrl"
        target="_blank"
        >创作者中心</a
      >
      <div class="account">
        <el-row
          class="block-col-2"
          v-if="getUserInfo.token">
          <el-col :span="12">
            <el-dropdown trigger="click">
              <img
                class="avatar"
                :src="userStore.user?.avatar_url || require('@/assets/user/defaultavatar.png')" />
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item icon="Setting"><a href="/user/settings/profile" target="_blank">我的设置</a></el-dropdown-item>
                  <el-dropdown-item
                    icon="TurnOff"
                    @click="logout"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
        </el-row>
        <span
          class="btn"
          v-else
          @click="userLogin()"
          >登录</span
        >
      </div>
    </div>
  </div>
  <el-divider />
</template>

<script lang="ts" setup>
import { computed, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserInfoStore } from "@/stores/userInfo";
import { useOAuthStore } from "@/stores/oauth";
import { ElMessageBox, ElMessage } from "element-plus";
import { useUIStore } from "@/stores/loginDialog";
import axiosInstance from "@/utils/axiosInstance";

const router = useRouter();
const userStore = useUserInfoStore();
const oauthStore = useOAuthStore();
const uiStore = useUIStore();

const userLogin = () => {
  if (!oauthStore.token) {
    uiStore.showLoginDialog();
  }
};

const creatorCenterUrl = computed(() => {
  const randomNumber = Math.floor(Math.random() * 90000000); // 生成一个随机数
  return `/creator/home?t=${randomNumber}`;
});

const getUserInfo = reactive({
  username: "",
  token: "",
});

onMounted(async () => {
  getUserInfo.username = computed(() => userStore.user?.uname ?? "");
  getUserInfo.token = oauthStore.token;
  fetchUserInfoTokenExpire();
});

// 退出登录
const logout = () => {
  ElMessageBox.confirm(
    "确定登出吗？程序员正在改变世界，我们需要你和我们在一起！",
    "温馨提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      //清除 userinfo token
      oauthStore.clearToken();
      userStore.clearUser();
      localStorage.clear();
      router.push("/").then(() => {
        location.reload();
      });
      ElMessage.success("退出登录成功！");
    })
    .catch(() => {
      //错误捕获
    });
};

// 获取用户信息
const fetchUserInfoTokenExpire = async () => {
  try {
    const randontime = Math.floor(Math.random() * 90000000);
    await axiosInstance
      .get("/api/UserLogin/IsTokenExpire", {
        params: { refreshtime: randontime },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          if (result.data.IsTokenExpire == 1) {
            //清除 userinfo token
            oauthStore.clearToken();
            userStore.clearUser();
            localStorage.clear();
          }
        }
      });
  } catch (error) {
    ElMessage.error("获取信息失败");
  }
};
</script>

<style scoped>
.el-divider--horizontal {
  margin: 0 !important;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 20px;
  margin: 0 auto;
  background: #fff;
  top: 0;
  left: 0;
  right: 0;
}
.nav-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  max-width: 1000px;
  margin-left: 215px;
}

.nav-left a {
  margin: auto 20px;
  color: #979797;
  font-size: 18px;
  text-decoration: none;
}
.nav-left a:first-child {
  margin-left: 0;
  margin-right: 34px;
}
.active {
  color: #333 !important;
  font-weight: 700;
}
.nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  height: 100%;
  margin-right: 300px;
}
.account img.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
}
.account .btn {
  padding: 5px 13px;
  border: 1px solid #e9e9e9;
  border-radius: 6px;
  color: #413e3b;
  font-size: 14px;
  cursor: pointer;
}
a.creatorbtn {
  display: inline-block;
  font-size: 14px;
  padding: 6px 20px;
  position: relative;
  text-align: center;
  text-decoration: none;
  border-radius: 6px;
  margin-right: 89px;
}
a.creatorbtn:hover {
  opacity: 0.9;
}
a.creatorbtn:active {
  top: 1px;
}
a.btn-primary {
  background: #cc5656;
  color: #fff;
}
</style>
